import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getAllOrderListAPI = (params, date, stateCity, callBack) => {
  return async () => {
    try {
      let url = ApiConstants.getAllOrderUrl;
      const queryParams = [];
      const stateCityParams = [];

      // Construct query parameters for pagination and search
      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(`limit=${encodeURIComponent(params.limit)}`);

      // Check for both start_date and end_date; if not present, set dateParams to null
      const dateParams =
        date.start_date && date.end_date
          ? [`start_date=${date.start_date}`, `end_date=${date.end_date}`]
          : null;

      // Check for both state and city before adding them to the URL
      if (stateCity.state && stateCity.city) {
        stateCityParams.push(`state=${stateCity.state}`);
        stateCityParams.push(`city=${stateCity.city}`);
      }

      // Append query parameters to URL if they exist
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      // Append date parameters to URL if they exist
      if (dateParams) {
        url += `${queryParams.length > 0 ? "&" : "?"}${dateParams.join("&")}`;
      }

      // Append state and city parameters to URL if they exist
      if (stateCityParams.length > 0) {
        url += `${queryParams.length > 0 || dateParams ? "&" : "?"
          }${stateCityParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getAllOrderStatusAPI = (params, callBack) => {
  return async () => {
    await apiGet(ApiConstants?.getAllOrderStatusAUrl)
      .then((response) => {
        callBack && callBack(response?.data, response?.data);
      })
      .catch((err) => {
        console.log("get all order status api err:", err);
        throw err;
      });
  };
};
export const getOrderByManufactureIdAPI = (manufactureId, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.getOrderByManufactureIdUrl}?manufacture_id=${manufactureId}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getMyOrdersAPI = (params, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.myOrdersUrl}`, { params })
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const createOrderAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createOrderUrl, data)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const updateOrderStatusAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.updateOrderStatusUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((error) => {
          console.log("update order status API err:", error);
          throw error;
        });
    } catch (error) {
      console.log("update order status API err:", error);
      throw error;
    }
  };
};

export const orderTrackingAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.orderTrackingUrl}?docket_number=${data}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get order tracking API err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get order tracking API err:", err);
      throw err;
    }
  };
};

export const createFeedBackRatingReviewAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants?.createFeedbackUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("create feeback API err:", err);
          throw err;
        });
    } catch (err) {
      console.log("create feeback API err:", err);
      throw err;
    }
  };
};

export const updateFeedBackRatingReviewAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants?.updateFeedbackUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update feeback API err:", err);
          throw err;
        });
    } catch (err) {
      console.log("update feeback API err:", err);
      throw err;
    }
  };
};

export const getFeebackRatingReviewAPI = (params, callBack) => {
  return async () => {
    try {
      let url = ApiConstants.getFeedBackRatingReviewUrl;
      const queryParams = [];

      if (params?.order_id)
        queryParams.push(`order_id=${encodeURIComponent(params.order_id)}`);
      if (params.feedback_type)
        queryParams.push(`feedback_type=${encodeURIComponent(params.feedback_type)}`);

      // Append query parameters to URL if they exist
      if (queryParams?.length > 0) {
        url += `?${queryParams.join("&")}`;
      }


      await apiGet(url)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get feedback rating review api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get feedback rating review api err:", err);
      throw err;
    }
  };
};

export const getFeedbackTypeAPI = (params, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants?.getFeedbackTypeUrl)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get feetdaback type API err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get feetdaback type API err:", err);
      throw err;
    }
  };
};

export const createPreOrderAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createPreOrderUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("create Pre Order API err:", err);
          throw err;
        });
    } catch (err) {
      console.log("create Pre Order API err:", err);
      throw err;
    }
  };
};

export const getUserTransactionsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getUserTransactionsAPI}?order_id=${data}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get user transaction api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user transaction api err:", err);
      throw err;
    }
  };
};

export const reInitiatePaymentAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.reInitiateTransactionAPI, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get user transaction api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("create re-initiate payment transaction api err:", err);
      throw err;
    }
  };
};

export const getPaymentMethodAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.paymentMethodUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get payment methodUrl api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get payment methodUrl api err:", err);
      throw err;
    }
  };
};
export const getPaymentGatewayAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.paymentGatewayUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get payment getway api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get payment getway api err:", err);
      throw err;
    }
  };
};
export const getPaymentStageAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.paymentStageUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get payment stage api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get payment stage api err:", err);
      throw err;
    }
  };
};
export const getTransactionSummaryAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getTransactionSummaryURL}?order_id=${data?.order_id}`)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          console.log("get transaction summary api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get transaction summary api err:", err);
      throw err;
    }
  };
};
